import apiClientAdmin from "../../../services/apiClientAdmin";
import { getHeaders as getAssetHeaders } from "../../ApiHeaders/apiHeaders";

/**
 * Creates an asset (`POST /assets/` on asset-metadata-service), as Asset Setup
 * and Onboarding both do. Returns the row the service sends back
 * (`response.data[0]`, which carries the new `asset_id`), or the submitted
 * payload when it sends none. Errors propagate to the caller.
 */
export async function createAsset(payload: any): Promise<any> {
  const headers = await getAssetHeaders();
  const res = await apiClientAdmin.post("/assets/", payload, { headers });
  return res?.data?.response?.data?.[0] || payload;
}

/** Every asset the caller can see: `GET /assets/` read page by page (200 a page). */
export async function fetchAllAssets(): Promise<any[]> {
  const headers = await getAssetHeaders();
  const pageSize = 200;
  let all: any[] = [];
  for (let page = 1; ; page += 1) {
    const res = await apiClientAdmin.get(`/assets/?page=${page}&page_size=${pageSize}`, {
      headers,
    });
    const fetched: any[] = res?.data?.response?.data ?? [];
    all = [...all, ...fetched];
    if (fetched.length !== pageSize) return all;
  }
}

let assetLookup: Promise<any[]> | null = null;

/**
 * fetchAllAssets, read once per page load and shared, for screens that only
 * need names (Access Explorer's asset-group rows). A failed read is retried on
 * the next call. Screens that must see a just-created asset call
 * fetchAllAssets directly.
 */
export function getAssetLookup(): Promise<any[]> {
  if (!assetLookup) {
    const p = fetchAllAssets();
    assetLookup = p;
    p.catch(() => {
      if (assetLookup === p) assetLookup = null;
    });
  }
  return assetLookup;
}

/** Forget the shared asset list: after creating an asset, after Fix all refreshes your access, on Access Explorer mount (and in tests). */
export function resetAssetLookup(): void {
  assetLookup = null;
}
